import React from "react";
import Product from "./Product";

export default function SearchResults({ searchTerm, searchResults, searching, onAddToCartPressed }) {
  if (!searchTerm?.trim()) return null;

  const products = Object.values(searchResults || {});

  return (
    <div className="search-results-container container">
      <h4 className="pt-4">{`Search Results for “${searchTerm}”`}</h4>
      {searching ? (
        <div className="pb-4">Searching...</div>
      ) : products.length > 0 ? (
        <section className="product-blocks">
          <div className="row">
            {products.map(product => (
              <Product
                key={product.productId}
                product={product}
                onAddToCartPressed={onAddToCartPressed}
              />
            ))}
          </div>
        </section>
      ) : (
        <div className="pb-4">No products found</div>
      )}
    </div>
  );
}